import React, { Component } from 'react';
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import {changeSetting} from "../../../../actions/actions";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class TimeoutSettings extends Component {

    constructor(props) {
        super(props);
        this.state={
            closed_timeout:this.props.chatprop.settings.chat_closed_timeout_active,
            closed_timeout_count:this.props.chatprop.settings.chat_closed_timeout_count

        }
        this.amountValue = React.createRef();
        this.changeClosedTimeOut=this.changeClosedTimeOut.bind(this);
        this.amountMinus = this.amountMinus.bind(this);
        this.amountPlus = this.amountPlus.bind(this);
        this.saveChanges = this.saveChanges.bind(this);

    }


    saveChanges(){
        var chat_closed_timeout_active=this.state.closed_timeout;
        var chat_closed_timeout_count=this.state.closed_timeout_count;
        this.props.dispatch(changeSetting({chat_closed_timeout_active:chat_closed_timeout_active,chat_closed_timeout_count:chat_closed_timeout_count}));

    }

    amountMinus(e){
        e.preventDefault();
        var amounts=parseInt(this.amountValue.current.value);

        if(amounts>1){
            amounts=amounts-1;
            this.amountValue.current.value=amounts;
        }
        this.setState({
            closed_timeout_count:amounts
        });
    }
    amountPlus(e){
        e.preventDefault();
        var amounts=parseInt(this.amountValue.current.value);
        if(amounts>9999){
            amounts=9999;
            this.amountValue.current.value=amounts;
        } else{
            if(isNaN(amounts)){
                amounts=1;
            }else{
                amounts=amounts+1;
            }
            this.amountValue.current.value=amounts;
        }
        this.setState({
            closed_timeout_count:amounts
        });
    }
    componentWillUnmount() {
        Swal.close();
    }

    changeClosedTimeOut(e){
        if(e.target.checked){
            var closed_timeout=1;
        } else{
            var closed_timeout=0;
        }
        this.setState({
            closed_timeout:closed_timeout
        });

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-item-container">
                    <div className="hv-setting-item">
                        <div className="chatSettingTimeoutContainer">

                                <div> When there are no new messages in the chat for  </div>
                                <div className="quantity">
                                                                <button type="button" className="amountMinus"  onClick={e=>this.amountMinus(e)}>
                                                                    <i className="bx bx-minus"></i>
                                                                </button>
                                                                <input type="text"  ref={this.amountValue} value={this.state.closed_timeout_count} className="text-center amountValue" disabled/>
                                                                <button type="button" className="amountPlus" onClick={e=>this.amountPlus(e)}><i className="bx bx-plus"></i>
                                                                </button>
                                </div>
                                <div>minutes, close the chat.</div>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.closed_timeout == 1 ? true : false}
                                    onChange={e => this.changeClosedTimeOut(e)}
                                    className="auto_assignment_change"
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>


                </div>
                <div className="submit mt-4">
                    <button className="btn btn-primary btn-sm "
                            onClick={()=>this.saveChanges()}>
                        save changes
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export default TimeoutSettings;
